import React from "react";
import { toast } from "react-toastify";
import {
  DatePicker, Select, Button, Table, Input,
} from "antd";
import dayjs from "dayjs";
import Error from "../../Error";
import "./PcrPosRetest.css";
import ConfirmationModal from "../../Common/ConfirmationModal";
import StatusTag from "../../Common/components/StatusTag";
import {
  getTestsDataForPcr,
  saveTestDataForPcr,
  markPcrSamplesNegative,
  fetchPlateMapIds,
} from "../../../actions/pcr";
import { checkReadyReports } from "../../../actions/sendReports";
import { getUser } from "../../../utils/helpers";

class PcrPosRetest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // activeTab: 1,
      genistaId: "",
      testsData: [],
      // testDataPending: [],
      rushSamplesDate: "",
      allSamplesDate: "",
      showError: { show: false, message: "" },
      loading: false,
      plateMapIds: [],
      selectedPlateMapId: null,
      plateMapLoading: false,
      selectedPlateMapDate: "",
      showApprovalConfirmationModal: false,
    };
    this.plateMapApiController = new AbortController();
  }

  componentDidMount() {
    // this.apiGetTestsDataForPcrPending();
  }

  resetState = () => {
    if (this.plateMapApiController) {
      this.plateMapApiController.abort();
    }
    this.plateMapApiController = new AbortController();
    this.setState({
      genistaId: "",
      testsData: [],
      rushSamplesDate: "",
      allSamplesDate: "",
      plateMapIds: [],
      selectedPlateMapId: null,
      plateMapLoading: false,
      selectedPlateMapDate: "",
      showApprovalConfirmationModal: false,
    });
  }

  // apiGetTestsDataForPcrPending = async () => {
  //   const response = await getTestsDataForPcrPending();
  //   if (response && response.success) {
  //     this.setState({ testDataPending: response.data });
  //   }
  // }

  // triggered when search button clicked
  handleSearchClick = (showSuccessMsg = false, negativeClicked = false, category = "") => {
    this.setState({ loading: true }, () => {
      const { genistaId } = this.state;
      const genistaIdNoSpace = genistaId.trim();
      this.apiGetTestsDataForPcr(genistaIdNoSpace).then((res) => {
        if (showSuccessMsg) {
          toast.success("Update Successful!");
        }
        if (negativeClicked) {
          this.handleNegativeSetState(category);
        }
        if (res) {
          if (res.length === 0) {
            this.setState({
              testsData: [],
              loading: false,
            });
            return;
          }

          this.setState({
            testsData: res || [],
            loading: false,
          });
        } else {
          toast.error("Something went wrong");
          this.setState({
            testsData: [],
            loading: false,
          });
        }
      });
    });
  }

  // api call to get a list of tests result to display on the table below
  apiGetTestsDataForPcr = async (data) => {
    const result = await getTestsDataForPcr(data, { category: "update" });
    if (result.success) {
      return result.data;
    }
    return null;
  }

  // triggered when click the the Positive / Reset button
  selectUpdateOption = (option, row) => {
    const { testsData } = this.state;
    this.apiSaveTestDataForPcr(testsData[row], option);
  }

  // api call to update Positive / Reset / Hold for the the test
  apiSaveTestDataForPcr = async (testData, option) => {
    const selectedRowGenistaId = testData.GenistaId;
    const params = {
      // Use Genista ID from selected row, not from search input.
      genista_id: selectedRowGenistaId,
      analysis: testData.Analysis,
      result: option,
      workorder_id: testData.WorkorderId ?? "",
    };
    this.setState({ loading: true }, async () => {
      const res = await saveTestDataForPcr(params);
      if (res.success) {
        const statusValue = typeof res.status === "string" ? res.status.toLowerCase() : "";
        if (statusValue === "waiting_approval") {
          this.handleSearchClick(false);
          this.setState({ showApprovalConfirmationModal: true });
        } else {
          this.handleSearchClick(true);
        }
      } else {
        const error = { show: true, message: res?.message || "Something went wrong" };
        this.toggleError(error);
        this.setState({ loading: false });
      }
    });
  }

  // api call to set all others tests to negative
  // handleNegativeClick = async (date, category) => {
  //   if (!date || date.length === 0) {
  //     toast.error("Please select a date.");
  //     return;
  //   }

  //   const selectedDate = date[0];
  //   const selectedDateStr = moment(selectedDate.getTime()).add(1, "days").format("MM/DD/YYYY");

  //   var params = { date: selectedDateStr, category: category }
  //   // const result = await setOthersNegative(params);
  //   // if (result && result.success) {
  //   //   if (category === "Rush") {
  //   //     toast.success("Marked Rush Samples Negative!");
  //   //   } else {
  //   //     toast.success("Marked All Samples Negative:!");
  //   //   }
  //   //   checkReadyReports()
  //   // }
  // }

  handleNegativeClick = async (e, date, category) => {
    if (date.length === 0) {
      toast.warning("Please select a date.");
      return;
    }
    this.setState({ loading: true }, async () => {
      const selectedDateStr = dayjs(date).format("MM/DD/YYYY");
      const params = {
        date: selectedDateStr,
        category,
        user_email: getUser()?.email,
      };
      const result = await markPcrSamplesNegative(params);
      if (result && result.success) {
        const { genistaId } = this.state;
        if (genistaId) {
          this.handleSearchClick(false, true, category);
        } else {
          this.handleNegativeSetState(category);
        }
      } else {
        const error = { show: true, message: result?.message || "Something went wrong" };
        this.toggleError(error);
        this.setState({
          loading: false,
        });
      }
    });
  }

  handleNegativeSetState = (category) => {
    toast.success(`Marked ${category} Samples Negative!`);
    this.setState({
      rushSamplesDate: "",
      allSamplesDate: "",
      loading: false,
    });
    checkReadyReports();
  }

  handleGenistaIdChange = (e) => {
    this.setState({ genistaId: e.target.value });
  }

  handlePlateMapIdSelect = (value) => {
    this.setState({ selectedPlateMapId: value });
  }

  handlePlateMapIdClear = () => {
    this.setState({ selectedPlateMapId: null });
  }

  toggleError = (error) => {
    this.setState({ showError: error });
  }

  closeApprovalConfirmationModal = () => {
    this.setState({ showApprovalConfirmationModal: false });
  }

  handleDate = (e, category) => {
    const date = e === null ? "" : e.format("YYYY-MM-DD");
    if (category === "rush") {
      this.setState({
        rushSamplesDate: date,
      });
    } else {
      this.setState({
        allSamplesDate: date,
      });
    }
  };

  // onDateChange = async (date) => {
  //   if (date.length === 1) {
  //     return false;
  //   }

  //   if (date.length > 1) {
  //     this.setState({
  //       startDate: date[0],
  //       endDate: date[1],
  //     });

  //     // const sdate = moment(date[0].getTime()).format("MM/DD/YY");
  //     // const edate = moment(date[1].getTime()).format("MM/DD/YY");

  //     // var result = await getLocationDates(activeLocationId, "Range", sdate, edate);
  //     // if (result && result.success) {
  //     //   this.setState({
  //     //     startDate: date[0],
  //     //     endDate: date[1],
  //     //     dateList: result[0].location_dates
  //     //   }, () => {
  //     //     if (result[0].location_dates.length === 0) {
  //     //       document.getElementById("formDataMsgOnCalendar").className = "msgOnCalendarShow";
  //     //     } else {
  //     //       document.getElementById("formDataMsgOnCalendar").className = "msgOnCalendarHide";
  //     //       this.onCloseDrop();
  //     //     }
  //     //   });
  //     // }
  //   }
  // }

  // handlPendingStatusClick = (e, row) => {
  //   var { testDataPending } = this.state;
  //   if (!!e && e !== "Select" && row >= 0) {
  //     testDataPending[row].option = e
  //     this.setState({testDataPending});
  //     this.apiSavePendingStatusForPcr(e);
  //   } else {
  //     toast.error("Something went wrong, please try later!");
  //   }
  // }

  // api call to update Positive / Reset / Hold for the the test
  // apiSavePendingStatusForPcr = async (option) => {
  //   const params = {
  //     // genista_id: this.state.genistaId,
  //     // analysis: testData["Analysis"],
  //     result: option
  //   }

  //   const res = await savePendingStatusForPcr(params);
  //   if (res.success) {
  //     toast.success("Update Successful!");
  //   }
  // }

    // fetch the plate map ids for the given date
    handlePlateMapDateChange = (e) => {
      const defaultPlateMapStates = {
        selectedPlateMapDate: "", plateMapLoading: false, plateMapIds: [], selectedPlateMapId: null,
      };
      if (this.plateMapApiController) {
        this.plateMapApiController.abort();
      }
      this.plateMapApiController = new AbortController();
      if (e === null) { // Clear the plate map date and reset the plate map ids when the date picker is cleared
        this.setState(defaultPlateMapStates);
        return;
      }
      this.setState({ selectedPlateMapDate: e, plateMapLoading: true }, async () => {
        const { selectedPlateMapDate } = this.state;
        const {
          result, message, success, canceled,
        } = await fetchPlateMapIds({ category: "get_info", date: selectedPlateMapDate.format("MM/DD/YYYY") }, this.plateMapApiController.signal);
        if (success) {
          this.setState({
            plateMapIds: result.map((plateMapData) => {
              const { platemap_id, updated } = plateMapData;
              return {
                value: platemap_id,
                label: platemap_id,
                disabled: updated === 1,
                title: updated === 1 ? "This plate map has already been marked" : platemap_id,
              };
            }),
            plateMapLoading: false,
            selectedPlateMapId: null,
          });
        } else if (!canceled) {
          this.setState(defaultPlateMapStates);
          toast.error(message);
        }
      });
    }

  handleMarkPlateMapSamplesNegative = async () => {
    const { selectedPlateMapId, selectedPlateMapDate } = this.state;
    const payload = {
      platemap_id: selectedPlateMapId,
      category: "Platemap",
      user_id: getUser()?.id,
    };
    this.setState({ loading: true }, async () => {
      const { success, message } = await markPcrSamplesNegative(payload);
      if (success) {
        this.handlePlateMapDateChange(selectedPlateMapDate); // Fetch the latest plate map ids again
        toast.success(message || "Marked Plate Map Samples Negative!");
      } else {
        toast.error(message);
      }
      this.setState({ loading: false });
    });
  }

  render() {
    const {
      genistaId,
      testsData,
      rushSamplesDate,
      allSamplesDate,
      showError,
      loading,
      plateMapIds,
      selectedPlateMapId,
      plateMapLoading,
      selectedPlateMapDate,
      showApprovalConfirmationModal,
    } = this.state;
    const tableDataSource = testsData.map((item, index) => ({
      ...item,
      key: `${item.WorkorderId}-${index}`,
      rowIndex: index,
    }));

    const tableColumns = [
      {
        title: "Workorder ID",
        dataIndex: "WorkorderId",
        key: "WorkorderId",
        onCell: () => ({ className: "PcrPosRetest__Table__Td" }),
      },
      {
        title: "Genista ID",
        dataIndex: "GenistaId",
        key: "GenistaId",
        onCell: () => ({ className: "PcrPosRetest__Table__Td" }),
      },
      {
        title: "Sample Type",
        dataIndex: "SampleType",
        key: "SampleType",
        onCell: () => ({ className: "PcrPosRetest__Table__Td" }),
      },
      {
        title: "Analysis",
        dataIndex: "Analysis",
        key: "Analysis",
        onCell: () => ({ className: "PcrPosRetest__Table__Td" }),
      },
      {
        title: "Result",
        dataIndex: "Result",
        key: "Result",
        onCell: () => ({ className: "PcrPosRetest__Table__Td" }),
      },
      {
        title: "Status",
        dataIndex: "Status",
        key: "Status",
        render: (status) => <StatusTag type="TEST_STATUS" result={status} />,
        onCell: () => ({ className: "PcrPosRetest__Table__Td" }),
      },
      {
        title: "Positive",
        key: "positive",
        render: (_, record) => (
          <button
            type="button"
            className="btn-save-pcr"
            onClick={() => this.selectUpdateOption("Positive", record.rowIndex)}
          >
            Positive
          </button>
        ),
        onCell: () => ({ className: "PcrPosRetest__Table__Td--100width" }),
      },
      {
        title: "Negative",
        key: "negative",
        render: (_, record) => (
          <button
            type="button"
            className="btn-save-pcr"
            onClick={() => this.selectUpdateOption("Negative", record.rowIndex)}
          >
            Negative
          </button>
        ),
        onCell: () => ({ className: "PcrPosRetest__Table__Td--100width" }),
      },
      {
        title: "Retest",
        key: "retest",
        render: (_, record) => {
          const retestButtonDisabled = String(record.Result).trim().toLowerCase() === "presumptive positive"
            && String(record.Status).trim().toLowerCase() === "retest";
          return (
            <button
              type="button"
              className="btn-save-pcr"
              disabled={retestButtonDisabled}
              title={retestButtonDisabled ? "Retest is already set" : undefined}
              onClick={() => this.selectUpdateOption("Retest", record.rowIndex)}
            >
              Retest
            </button>
          );
        },
        onCell: () => ({ className: "PcrPosRetest__Table__Td--100width" }),
      },
      // {
      //   title: "Hold",
      //   key: "hold",
      //   render: (_, record) => (
      //     <button
      //       type="button"
      //       className="btn-save-pcr"
      //       onClick={() => this.selectUpdateOption("Hold", record.rowIndex)}
      //     >
      //       Hold
      //     </button>
      //   ),
      // },
    ];

    return (
      <div>
        <div className="PcrPosRetest__Header">
          Please input Genista ID to get the analysis
        </div>
        <div className="PcrPosRetest__SearchRow">
          <Input.Search
            className="PcrPosRetestSearch"
            placeholder="Input Genista ID"
            value={genistaId}
            onChange={this.handleGenistaIdChange}
            onSearch={() => this.handleSearchClick()}
            allowClear
          />
        </div>
        <Table
          bordered
          loading={loading}
          columns={tableColumns}
          dataSource={tableDataSource}
          pagination={false}
          rowClassName={() => "PcrPosRetest__Table__Tr"}
        />
        <div>
          {/* <button
            type="button"
            className="pctSearchBtn"
            style={{width: "240px", marginTop: "50px", float: "left", background: "#ffa500"}}
            onClick={() => this.handleNegativeClick("Rush")}
          >
            Mark Negative with Rush
          </button> */}
          <div className="PcrPosRetest__Row">
            <div className="PcrPosRetest__MarkText">
              Mark Rush Samples Negative:
            </div>
            {/* <Flatpickr
            options={{
              dateFormat: "m-d-Y",
              maxDate: new Date(),
              altInput: false
            }}
            placeholder="Select a date"
            style={{ width: '140px', margin: "0px"}}
            onChange={(date) => this.handleNegativeClick(date, "Rush")}
          /> */}
            <DatePicker
              format="MM/DD/YYYY"
              className="PcrPosRetest__DatePicker"
              value={(rushSamplesDate === "" || rushSamplesDate === "Invalid date") ? "" : dayjs(rushSamplesDate)}
              defaultValue={(rushSamplesDate === "" || rushSamplesDate === "Invalid date") ? "" : dayjs(rushSamplesDate)}
              onChange={(e) => this.handleDate(e, "rush")}
              placeholder="mm/dd/yyyy"
            />
            <Button type="primary" disabled={!rushSamplesDate} onClick={(e) => this.handleNegativeClick(e, rushSamplesDate, "Rush")}>Submit</Button>
          </div>
          {/* <button
            type="button"
            className="pctSearchBtn"
            style={{width: "240px", float: "right", marginTop: "50px"}}
            onClick={() => this.handleNegativeClick("Regular")}
          >
            Mark Negative with Regular
          </button> */}
          <div className="PcrPosRetest__Row">
            <div className="PcrPosRetest__MarkText">
              Mark All Samples Negative:
            </div>
            {/* <Flatpickr
            options={{
              dateFormat: "m-d-Y",
              maxDate: new Date(),
              altInput: false
            }}
            placeholder="Select a date"
            style={{ width: '140px',marginTop: "0px"}}
            onChange={(date) => this.handleNegativeClick(date, "Regular")}
          /> */}
            <DatePicker
              format="MM/DD/YYYY"
              className="PcrPosRetest__DatePicker"
              value={(allSamplesDate === "" || allSamplesDate === "Invalid date") ? "" : dayjs(allSamplesDate)}
              defaultValue={(allSamplesDate === "" || allSamplesDate === "Invalid date") ? "" : dayjs(allSamplesDate)}
              onChange={(e) => this.handleDate(e, "all")}
              placeholder="mm/dd/yyyy"
            />
            <Button type="primary" disabled={!allSamplesDate} onClick={(e) => this.handleNegativeClick(e, allSamplesDate, "Regular")}>Submit</Button>
          </div>
          <div className="PcrPosRetest__Row">
            <div className="PcrPosRetest__MarkText">
              Mark Plate Map Samples Negative:
            </div>
            <DatePicker
              format="MM/DD/YYYY"
              placeholder="mm/dd/yyyy"
              className="PcrPosRetest__DatePicker"
              value={selectedPlateMapDate}
              onClear={() => this.handlePlateMapDateChange(null)}
              onChange={(e) => this.handlePlateMapDateChange(e)}
            />
            <Select
              showSearch
              allowClear
              className="PcrPosRetest__PlateMapSelect"
              popupClassName="PcrPosRetest__PlateMapSelect__DropdownPanel"
              placeholder="Plate Map"
              options={plateMapIds}
              onSelect={this.handlePlateMapIdSelect}
              value={selectedPlateMapId}
              loading={plateMapLoading}
              onClear={this.handlePlateMapIdClear}
            />
            <Button type="primary" disabled={!selectedPlateMapId || plateMapLoading} onClick={this.handleMarkPlateMapSamplesNegative}>Submit</Button>
          </div>
        </div>

        {/* <div style={{marginTop: "140px", fontFamily: "Roboto Bold", fontSize: "20px", color: "#27aae1"}}>Pending</div>
        <div style={{height: "2px", marginBottom: "60px", border: "2px dashed #27aae1"}} />

        <Table striped bordered hover>
          <thead>
            <tr>
              <th>OrderId</th>
              <th>GenistaId</th>
              <th>Analysis</th>
              <th>Operation</th>
            </tr>
          </thead>
          <tbody>
          {testDataPending && testDataPending.length > 0 && testDataPending.map((item, index) => {
            return (
              <tr key={index} style={{minWidth: "600px"}}>
                <td style={{verticalAlign: "middle"}}>{item["OrderId"]}</td>
                <td style={{verticalAlign: "middle"}}>{item["GenistaId"]}</td>
                <td style={{verticalAlign: "middle"}}>{item["Analysis"]}</td>
                <td style={{width: "150px"}}>
                  <DropdownButton title={item.option} onSelect={(event) => this.handlPendingStatusClick(event, index)}>
                    <Dropdown.Item eventKey="Positive">Positive</Dropdown.Item>
                    <Dropdown.Item eventKey="Negative">Negative</Dropdown.Item>
                    <Dropdown.Item eventKey="Retest">Retest</Dropdown.Item>
                  </DropdownButton>
                </td>
              </tr>
            )
          })}
          </tbody>
        </Table> */}
        <div className="PcrPosRetest__Gap" />
        {showError.show
          && <Error message={showError.message} toggleError={this.toggleError} />}
        <ConfirmationModal
          open={showApprovalConfirmationModal}
          onOk={this.closeApprovalConfirmationModal}
          showCancelButton={false}
          okText="Confirm"
          title="Pathogen Update Pending Approval"
          bodyText="Your pathogen result update has been submitted. It's now waiting for approval. If approved, the update will be applied automatically."
        />
      </div>
    );
  }
}

export default PcrPosRetest;
